import * as _ from "lodash-es";
import React, { Component } from "react";
import IDeleteFileUploadDTO from "../../../models/DTO/IDeleteFileUploadDTO";
import IGetFileUploadDTO from "../../../models/DTO/IGetFileUploadDTO";
import IOnGetFileUpload from "../../../models/DTO/IOnGetFileUpload";
import EndpointsEnum from "../../../models/EndpointsEnum";
import FileUploadResourceTypeEnum from "../../../models/FileUploadResourceTypeEnum";
import IOrder from "../../../models/IOrder";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import AlertModal from "../../shared/AlertModal/AlertModal";
import OwS3Uploader from "../../shared/OwS3Uploader/OwS3Uploader";
import AttachmentListItem from "./AttachmentListItem/AttachmentListItem";
import "./OrderEntryFileManager.scss";
import { Socket } from "socket.io-client";
import IUiSocketSetup from "../../../models/IUiSocketSetup";

type Props = {
    supplierModel: ISupplierModel;
    userModel: IUserUI;
    orderGuid?: string;
    vendorModel?: IVendorModel;
    socket: Socket;
    orderModel?: IOrder;
    isReadOnly: boolean;
};

type State = {
    showAlert: boolean;
    retrievingFile: boolean;
};

class OrderEntryFileManager extends Component<Props, State> {
    sockets: IUiSocketSetup[] = [];

    readonly state: State = {
        showAlert: false,
        retrievingFile: false,
    };

    constructor(props: Props) {
        super(props);

        this.sockets = [{ endpoint: EndpointsEnum.FileUploadOnGetFileUpload, fn: this.onGetFileUpload }];
    }

    componentDidMount(): void {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }
    }

    componentWillUnmount(): void {
        for (const socket of this.sockets) {
            this.props.socket.off(socket.endpoint, socket.fn);
        }
    }

    onGetFileUpload = (data: IOnGetFileUpload) => {
        // console.log("onGetFileUpload", data);
        if (this.state.retrievingFile) {
            const blob = new Blob([data.Body], { type: data.ContentType });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            const attachment = _.find(this.props.orderModel!.attachments, (attachment) => {
                return attachment.etag === data.ETag;
            });

            if (attachment) {
                const fileName = attachment.name;

                link.download = fileName;
                link.click();

                this.setState({
                    retrievingFile: false,
                });
            } else {
                this.setState({
                    showAlert: true,
                    retrievingFile: false,
                });
            }
        }
    };

    downloadAttachment = (attachmentGuid: string) => {
        const payload: IGetFileUploadDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            attachmentGuid: attachmentGuid,
            vendorGuid: this.props.vendorModel ? this.props.vendorModel.guid : undefined,
        };

        this.props.socket.emit(EndpointsEnum.FileUploadGetFileUpload, payload);

        this.setState({
            retrievingFile: true,
        });
    };

    deleteAttachment = (attachmentGuid: string) => {
        const payload: IDeleteFileUploadDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            attachmentGuid: attachmentGuid,
            vendorGuid: this.props.vendorModel ? this.props.vendorModel.guid : undefined,
        };

        this.props.socket.emit(EndpointsEnum.FileUploadDeleteFileUpload, payload);
    };

    render() {
        const attachments = this.props.orderModel ? this.props.orderModel.attachments : [];

        const attachmentItems = _.map(attachments, (attachment, index) => {
            return (
                <AttachmentListItem
                    key={index}
                    attachment={attachment}
                    downloadAttachment={this.downloadAttachment}
                    deleteAttachment={this.deleteAttachment}
                    isReadOnly={this.props.isReadOnly}
                />
            );
        });

        let workflowUploadsReadOnly = this.props.isReadOnly;

        if (this.props.orderModel?.Workflow) {
            const currentStateId = this.props.orderModel.order_state_id;

            if (currentStateId) {
                for (const workflowState of this.props.orderModel.Workflow.detail) {
                    if (workflowState.order_state_id === currentStateId) {
                        if (workflowState.allowFileUploadIfReadOnly) {
                            workflowUploadsReadOnly = false;
                        }
                    }
                }
            }
        }

        return (
            <div className="OrderEntryFileManager d-flex flex-wrap row">
                <div className={"col-md-3 col-12"}>
                    <OwS3Uploader
                        supplierModel={this.props.supplierModel}
                        socket={this.props.socket}
                        userModel={this.props.userModel}
                        orderGuid={this.props.orderGuid}
                        vendorModel={this.props.vendorModel}
                        isReadOnly={workflowUploadsReadOnly}
                        resourceType={FileUploadResourceTypeEnum.orderItem}
                    />
                </div>
                <hr className={"d-md-none"} />
                <div className={"d-none d-md-inline-flex col-md-auto"}>
                    <div className="d-inline-block h-100" style={{ width: "1px", backgroundColor: "#CCC" }}></div>
                </div>
                <div className={"col-12 col-md-8"}>{attachmentItems}</div>

                <AlertModal
                    title={"error_downloading_file"}
                    message={"please_contact_support"}
                    closeFn={() => {
                        this.setState({ showAlert: false });
                    }}
                    showAlert={this.state.showAlert}
                />
            </div>
        );
    }
}

export default OrderEntryFileManager;
